module.exports = __webpack_public_path__ + "static/media/25.94e3e139.jpg";